// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1vdjw","inner":"Footer_inner__1hj59","nextIcon":"Footer_nextIcon__3AqPX","innerLeft":"Footer_innerLeft__3xRXP"};